import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class ComputeServiceVc {
    private vcList: any;

    constructor(public http: HttpClient) {
    }

    getVcList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vc/query?entityType=vcenter')
            .map(res => this.vcList = res);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vc/dashboard-vc/compute-vc.service.ts